// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/chunks/" + (chunkId === 949 ? "f2a0b476" : chunkId) + "." + {"352":"c37cbc74cb2a7fa1","360":"78984efbe4959325","949":"574d823aa9678882"}[chunkId] + ".js";
};